import React from 'react';
import { UserMessagePayload, BotChatMessage, MediaUserChatMessage, TextUserChatMessage } from './types';

const TYPEWRITER_CHARS_PER_TICK = 2;
const TYPEWRITER_TICK_MS = 28;

export function createBotMessage(text: string): BotChatMessage {
  return { id: `bot-${Date.now()}-${Math.random()}`, role: 'bot', text };
}

export function createUserMessage(payload: UserMessagePayload): TextUserChatMessage | MediaUserChatMessage {
  const id = `user-${Date.now()}-${Math.random()}`;

  if (payload.type === 'media') {
    return {
      id,
      role: 'user',
      type: 'media',
      mediaType: payload.mediaType,
      url: payload.url,
      fileName: payload.fileName,
    };
  }

  return { id, role: 'user', type: 'text', text: payload.text };
}

export function useTypewriter(text: string, enabled: boolean) {
  const [displayed, setDisplayed] = React.useState(enabled ? '' : text);
  const [isDone, setIsDone] = React.useState(!enabled);

  React.useEffect(() => {
    if (!enabled) {
      setDisplayed(text);
      setIsDone(true);
      return;
    }

    setDisplayed('');
    setIsDone(false);
    let index = 0;

    const intervalId = window.setInterval(() => {
      index = Math.min(index + TYPEWRITER_CHARS_PER_TICK, text.length);
      setDisplayed(text.slice(0, index));

      if (index >= text.length) {
        window.clearInterval(intervalId);
        setIsDone(true);
      }
    }, TYPEWRITER_TICK_MS);

    return () => window.clearInterval(intervalId);
  }, [text, enabled]);

  return { displayed, isDone };
}